import React from 'react';
import { useIntegrationResult } from '../../features/integrations/hooks/useIntegrationResult';

const SuccessView: React.FC = () => {
  useIntegrationResult();
  return null;
};

export default SuccessView;
